__turbopack_context__.v({
  "horizontal": "Divider-module__2yEGEG__horizontal",
  "vertical": "Divider-module__2yEGEG__vertical",
});
